import { useOutletContext } from "react-router-dom";
import ChangePassword from "../../components/ChangePassword";

const AccountPage = () => {
  const { agent } = useOutletContext();

  return (
    <div className="h-full overflow-y-auto p-6">
      <ChangePassword agent={agent} />
    </div>
  );
};

export default AccountPage;
